import React from 'react';
import { View } from '@apps/createWedding/components/View';
import { JoyLogoLoader } from '@shared/components/JoyLogoLoader';
import { useCreateWeddingController } from '@apps/createWedding/CreateWedding.controller';
import {
  WeddingContentWrapper,
  StyledCreateWeddingRoot,
  Background,
  StyledOnboardingRoot,
  SidebarRoot,
  ContentRoot,
  SidebarContainer,
  SidebarContentWrapper,
  Variant2Img
} from './CreateWedding.styles';
import { TextV2 } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';
import { useLocaleDisclaimer } from '@apps/createWedding/hooks/useLocaleDisclaimer';

export const CreateWedding = () => {
  const { isLoading, desiredView } = useCreateWeddingController();
  const { t } = useTranslation('createWedding');
  const translations = t('createAccount');
  const localeDisclaimer = useLocaleDisclaimer();

  if (isLoading) {
    return <JoyLogoLoader loaderKey="createwedding" />;
  }

  return (
    <StyledCreateWeddingRoot>
      <Background>
        <StyledOnboardingRoot>
          <SidebarRoot>
            <SidebarContainer>
              <SidebarContentWrapper>
                <TextV2 paddingBottom={8} typographyVariant={'Hed40'}>
                  {translations.sidebarText()}
                </TextV2>
                <Variant2Img src="https://withjoy.com/assets/public/createwedding/create-wedding-variant-2.png?opt=mild" />
              </SidebarContentWrapper>
            </SidebarContainer>
          </SidebarRoot>
          <ContentRoot>
            <WeddingContentWrapper paddingTop={7} paddingBottom={8} paddingX={7} flexDirection="column" alignItems="center" justifyContent={['center']}>
              {localeDisclaimer && (
                <TextV2 textAlign="center" color="negative6" typographyVariant={'label3'}>
                  {localeDisclaimer}
                </TextV2>
              )}
              <View defaultView={desiredView} isExperimentControl={false} />
            </WeddingContentWrapper>
          </ContentRoot>
        </StyledOnboardingRoot>
      </Background>
    </StyledCreateWeddingRoot>
  );
};
